import { render } from "./confirmResearchModal.vue?vue&type=template&id=31dcb4c8&scoped=true"
import script from "./confirmResearchModal.vue?vue&type=script&lang=js"
export * from "./confirmResearchModal.vue?vue&type=script&lang=js"

import "./confirmResearchModal.vue?vue&type=style&index=0&id=31dcb4c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dcb4c8"]])

export default __exports__